import ReactPlayer from "react-player";
import styles from "../../../../pages/docs/code/video.module.css";
import AwesomeLoaders from "../../../../pages/docs/code/rug";
import * as React from 'react';
export default {
  ReactPlayer,
  styles,
  AwesomeLoaders,
  React
};